import { forwardRef } from 'react';

import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import EventCardV1 from './EventCard/v1';
import { EventCardV2 } from './EventCard/v2';
import { type EventCardProps } from './types';

const EventCard = forwardRef<HTMLDivElement, EventCardProps>((props, ref) => {
  const { flagEvNewEventFoCard } = useFeatureFlag();

  if (flagEvNewEventFoCard) {
    return <EventCardV2 {...props} ref={ref} />;
  }

  return <EventCardV1 {...props} ref={ref} />;
});

export default EventCard;
